import Reveal from "@/components/7fcc/Reveal";
import CTAButton from "@/components/7fcc/CTAButton";

// Last-call CTA at the bottom of the page — scrolls back up to the form.
export default function BottomCta() {
  return (
    <section className="bg-ink-950 px-6 py-14 text-center md:py-16" data-testid="bottom-cta">
      <Reveal>
        <CTAButton label="See If You Qualify Here" targetId="qualify" testId="bottom-cta" />
      </Reveal>
    </section>
  );
}
